//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  name: "Menu",
  props: ["leftDrawerOpen"],

  components: {},
  data() {
    return {
      alwaysOpen: true,
      size: "xs",
      show: {
        Home: true,
        Orders: true,
        Report: true,
        Purchase: true,
        Stock: true,
        Registre: true,
        Settings: true,
        UserSettings: false,
        AdminSettings: true,
      },
    };
  },

  computed: {
    ...mapState("main", ["user", "appVersion"]),
  },
  methods: {},
};
